import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const getCapabilitiesApi = async (authHeaders) => {
    const apiInputData = {
        operation: "GET_USER_CAPABILITIES"
    };
    try {
        const res = await apiCallPost(apiPaths.capabilities, apiInputData, authHeaders);
        if (res) {
            return { data: res, status: true };
        }
        return { data: {}, status: false, errMsg: 'Failed to fetch capabilities' };
    } catch (err) {
        return { status: false, errMsg: err.message };
    }
}
